import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    classPlan: [],
    isLogging: false,
    selectedClassPlan: '',
    isClassPlanUpdate: false,

}

export const classPlanSlice = createSlice({
    name: 'classPlanCreator',
    initialState,
    reducers: {
        setClassPlan: (state, action) => {
            state.classPlan = action.payload
        },
        setSelectedClassPlan: (state, action) => {
            state.selectedClassPlan = action.payload
        },
        setUpdateClassPlan: (state, action) => {
            state.isClassPlanUpdate = action.payload
        }
    },
})

// Action creators are generated for each case reducer function
export const {setClassPlan, setSelectedClassPlan, setUpdateClassPlan} = classPlanSlice.actions

export default classPlanSlice.reducer
